"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultReverifyEmailState = exports.defaultReverifyEmailFormTranslation = exports.defaultReverifyEmailForm = exports.defaultReverifyEmailTranslate = void 0;
exports.defaultReverifyEmailTranslate = {
    nameReverifyEmailTitle: 'Resend Account Verification email',
    nameReverifyEmailCaption: 'Enter your email to resend verification email',
    needSupportTitle: 'Need Support?',
    needSupportEmail: 'info@okay.com',
    needSupportPhone: '1234 5678',
};
exports.defaultReverifyEmailForm = {
    email: '',
};
exports.defaultReverifyEmailFormTranslation = {
    email: 'Email',
    recaptchaKey: '6Le-cFUUAAAAADF1araSd_vyQ9ig1Py8nhZF9Fid',
    nameSubmit: 'Submit',
    emailFormat: 'Invalid email format',
    emailRequired: 'Email is required',
};
exports.defaultReverifyEmailState = {
    t: exports.defaultReverifyEmailTranslate,
    form: exports.defaultReverifyEmailForm,
    tForm: exports.defaultReverifyEmailFormTranslation,
    isLoading: false,
};
